import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { ProvinceAutoComplete } from 'models/provinceAutoComplete';
import { searchProvincesAutocomplete } from 'actions/provincesAutocomplete';
import ProvincesAutoCompleteSearch from 'components/ProvincesAutoCompleteSearch';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (country?: ProvinceAutoComplete) => void;
  countryCode?: string;
}

const AutoCompleteProvincesSearchContainer = (props: Props) => {

  const { countryCode } = props;
  const dispatch = useDispatch();
  const provincesState = useSelector((state: RootState) => state.provincesAutoComplete);

  const handleSearchChange = _.debounce((value: string) => {

    if (value && value.length > 0) {
      dispatch(searchProvincesAutocomplete(value, countryCode));
    }
  }, 250);

  return <ProvincesAutoCompleteSearch {...props} {...provincesState} minLengthForSearch={2} onSearchChange={handleSearchChange} />;
};

export default AutoCompleteProvincesSearchContainer;
